import { Link } from "react-router-dom";

const VisualSitemap = () => {
  return (
    <div className="bg-gray-100 pb-20 pt-36">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start text-sm text-gray-700">

          {/* Column 1: Heading */}
          <div className="flex justify-center items-center min-w-[150px]">
            <h2 className="text-4xl font-semibold text-green-600 text-center">Sitemap</h2>
          </div>

          {/* Column 2: Pages */}
          <div className="min-w-[100px]">
            <h4 className="font-bold text-gray-900 mb-4 "><span className="border border-cyan-900 px-4 py-2">Pages</span></h4>
            <ul className="space-y-1 px-4">
              <li><Link to="/" className="text-blue-600 hover:text-blue-800">Home</Link></li>
              <li><Link to="/about" className="text-blue-600 hover:text-blue-800">About</Link></li>
              <li><Link to="/contact" className="text-blue-600 hover:text-blue-800">Contact</Link></li>
              <li><Link to="/faq" className="text-blue-600 hover:text-blue-800">FAQ</Link></li>
            </ul>
          </div>

          {/* Column 3: Products */}
          <div className="min-w-[200px]">
            <h4 className="font-bold text-gray-900 mb-4"><span className="border border-cyan-900 px-4 py-2">Products</span></h4>
            <ul className="space-y-1 px-4">
              <li><Link to="/product/4g-smart-safety-helmet-camera" className="text-blue-600 hover:text-blue-800">4G Smart Helmet Camera</Link></li>
              <li><Link to="/product/rfi-digital-drift-leaky-feeder" className="text-blue-600 hover:text-blue-800">RFI Digital Drift Leaky Feeder</Link></li>
            </ul>
            <h4 className="font-bold text-gray-600 mt-4 mb-2 px-4">PoC Radios</h4>
            <ul className="space-y-1 px-4">
              <li><Link to="/product/xtreme-xp-100" className="text-blue-600 hover:text-blue-800">Xtreme XP-100</Link></li>
              <li><Link to="/product/xtreme-xm-510" className="text-blue-600 hover:text-blue-800">Xtreme XM-510</Link></li>
              <li><Link to="/product/xtreme-xp-446" className="text-blue-600 hover:text-blue-800">Xtreme XP-446</Link></li>
              <li><Link to="/product/xtreme-xp-880" className="text-blue-600 hover:text-blue-800">Xtreme XP-880</Link></li>
              <li><Link to="/product/xtreme-xp-960" className="text-blue-600 hover:text-blue-800">Xtreme XP-960</Link></li>
            </ul>
            <h4 className="font-bold text-gray-600 mt-4 mb-2 px-4">Body Camera</h4>
            <ul className="space-y-1 px-4">
              <li><Link to="/product/xtreme-xb-15" className="text-blue-600 hover:text-blue-800">Xtreme XB-15</Link></li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default VisualSitemap;
